import { useStore } from "ra-core";

// Sprint 8 — Toggle classique ↔ agent par page, persisté via le store ra-core
// (localStorage, clé `RaStore.page-mode:<page>`).
// ponytail: the old raw `page-mode:<page>` key isn't migrated — prefs reset to "classic" once.

export type PageId = "dev" | "companies" | "appointments";
export type PageMode = "classic" | "agent";

export function usePageMode(
  page: PageId,
  defaultMode: PageMode = "classic",
): [PageMode, (next: PageMode) => void, () => void] {
  const [mode, setMode] = useStore<PageMode>(`page-mode:${page}`, defaultMode);
  const toggle = () => setMode(mode === "agent" ? "classic" : "agent");
  return [mode, setMode, toggle];
}
